import { alpha, Box, styled } from "@mui/material";

export const LegendRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(3),
  flexWrap: "wrap",
  flexShrink: 0,
  marginTop: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  fontSize: "0.75rem",
  color: theme.palette.text.secondary,
}));

export const LegendTitle = styled("span")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: "0.7rem",
  letterSpacing: "0.02em",
  textTransform: "uppercase",
}));

export const LegendItem = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  whiteSpace: "nowrap",
});

export const LegendSwatch = styled("span", {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant: "increase" | "decrease" }>(({ theme, variant }) => {
  const color = variant === "increase" ? theme.palette.error.main : theme.palette.success.main;
  return {
    display: "inline-block",
    width: 14,
    height: 14,
    borderRadius: 3,
    backgroundColor: alpha(color, 0.3),
    border: `1px solid ${alpha(color, 0.6)}`,
  };
});
